import { StoreState } from '../../../redux/reducers/store.types';
import { AccordionState } from './accordion.reducer';

export const getAccordionState = (state: StoreState): AccordionState =>
  state.accordion;
